// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YNJaw","right":"styles_right__1Pldx"};